export default "__VITE_ASSET__CrXlsh_v__"